import { Controller } from "@hotwired/stimulus"

// Paddle Checkout 오버레이를 제어한다.
export default class extends Controller {
  static values = {
    environment: String,
    items: Array,
    customer: Object,
    successUrl: String,
    cancelUrl: String,
    publishableToken: String
  }

  connect() {
    this.initialized = false
    this.loadPaddleScript()
  }

  loadPaddleScript() {
    if (window.Paddle) {
      this.initializePaddle()
      return
    }

    const existingScript = document.querySelector('script[data-paddle-sdk]')
    if (existingScript) {
      existingScript.addEventListener("load", () => this.initializePaddle(), { once: true })
      return
    }

    const script = document.createElement("script")
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js"
    script.async = true
    script.dataset.paddleSdk = "true"
    script.addEventListener("load", () => this.initializePaddle(), { once: true })
    document.head.appendChild(script)
  }

  initializePaddle() {
    const Paddle = window.Paddle
    if (!Paddle || this.initialized) {
      return
    }

    const env = this.hasEnvironmentValue ? this.environmentValue : "sandbox"
    if (Paddle.Environment && Paddle.Environment.set) {
      Paddle.Environment.set(env)
    }

    if (this.hasPublishableTokenValue && Paddle.Initialize) {
      try {
        Paddle.Initialize({ token: this.publishableTokenValue })
      } catch (error) {
        console.error("[PaddleCheckoutController] Paddle 초기화 실패:", error)
      }
    }

    this.initialized = true
  }

  open(event) {
    event.preventDefault()

    const Paddle = window.Paddle
    if (!Paddle) {
      console.error("[PaddleCheckoutController] Paddle SDK가 아직 로드되지 않았습니다.")
      return
    }

    const payload = {
      items: this.itemsValue,
      customer: this.customerValue,
      settings: {
        displayMode: "overlay",
        locale: "ko-KR",
        successUrl: this.hasSuccessUrlValue ? this.successUrlValue : undefined,
        cancelUrl: this.hasCancelUrlValue ? this.cancelUrlValue : undefined
      }
    }

    try {
      Paddle.Checkout.open(payload)
    } catch (error) {
      console.error("[PaddleCheckoutController] 결제 창 호출 실패:", error)
    }
  }
}
